import $ from "jquery";

export const init = () => {
  if ($(".ce_falfilebrowser_searchwords .searchwords a").length > 0) {
    $(".ce_falfilebrowser_searchwords .searchwords a").on(
      "click",
      function (e) {
        e.preventDefault();
        let target = $(this).attr("href");
        let value = $(this).attr("data-value");
        if (target && value) $(target).val(value);
        $(target).parents("form").submit();
        return false;
      }
    );
  }
};
